import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_RELEASE_SPEAKER_VERSION } from "src/constants/actionCache";
import ShowCacheReleaseSpeakerVersion from "../ShowCache/ShowCacheReleaseSpeakerVersion";
import ReleaseSpeakerVersionPopup from "../Popup/ReleaseSpeakerVersionPopup";

const ReleaseSpeakerVersionControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
  releaseTypeSpeakerId,
  environmentId,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Release Speaker Version"
          isShowButton={isShowCache(
            currentActionCache,
            CACHE_RELEASE_SPEAKER_VERSION
          )}
        >
          <ShowCacheReleaseSpeakerVersion
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <ReleaseSpeakerVersionPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
          releaseTypeSpeakerId={releaseTypeSpeakerId}
          environmentId={environmentId}
        />
      </div>
    </div>
  );
};

export default ReleaseSpeakerVersionControlPanel;
